import * as React from 'react'
import { TextLocalizer } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import { tryCatch } from '../../utils/tryCatch'
import * as utilityClasses from '../utilityClasses.module.scss'
import { Button } from 'DVWebNodeUI'
import { ModalTrigger } from '../../utils/ModalTrigger';
import { MwtwModal } from '../acquisition/moreWaysToWatchModal';
import * as WpsRuntime from 'DVWebNodeWpsRuntime'

export interface IATFMorePurchaseOptionProps {
  shouldShowMoreWaysToWatch: boolean
  moreWaysToWatch?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
  titleId?: string
}

export const AtfMorePurchaseOptions = tryCatch(
  ({
    shouldShowMoreWaysToWatch,
    moreWaysToWatch,
    titleId,
  }: IATFMorePurchaseOptionProps) => {
    return shouldShowMoreWaysToWatch && titleId ? (
      <div
        className={`${utilityClasses.stretchHeight} ${utilityClasses.fullWidthPhablet}`}
      >
        <ModalTrigger
          modalId="dvui-close-overlay-atf-mwtw"
          modalContent={({ closeModal }) => (
            <MwtwModal
              closeModal={closeModal}
              moreWaysToWatch={moreWaysToWatch}
            />
          )}
          toggle={({ openModalClickHandler }) => (
            <Button
              data-ux-click
              onClick={openModalClickHandler}
              name="more-purchase-options"
            >
              <TextLocalizer stringID={StringId.DV_MWTW_TITLE_MAIN} />
            </Button>
          )}
        />
      </div>
    ) : null
  }
)
